export default __webpack_public_path__ + "static/media/brand-story-mamoru.ef67ffc1.png";